import { withInstall } from '@ll-plus/utils'

import FloatButtonGroup from './src/float-button-group.vue'
import FloatButton from './src/float-button.vue'

export const LlFloatButton = withInstall(FloatButton)
export const LlFloatButtonGroup = withInstall(FloatButtonGroup)

export * from './src/float-button'

declare module 'vue' {
  export interface GlobalComponents {
    LlFloatButton: typeof FloatButton
    LlFloatButtonGroup: typeof FloatButtonGroup
  }
}
